import BusSystemApi from './_busSystemApi';

class DepartmentApi extends BusSystemApi {
  constructor() {
    super();
  }
  apiName = 'BusinessSystem';
  controllerName = 'Departments';

  /**
   * xóa phòng ban trong luồng getting (hợp nhất đơn vị)
   * vqphong - 23/07/2025
   */
  deleteGettingDepartment() {
    const request = {
      url: this.getAPIUrl() + `/delete-child-departments`,
    };

    return this.postAsync(request);
  }
}

export default new DepartmentApi();
